"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getString = exports.anonymizeEmail = void 0;
var anonymizeEmail = function (email) {
    if (!email) {
        return '***';
    }
    var _a = email.split('@'), localPart = _a[0], domain = _a[1];
    if (!localPart || !domain) {
        return '***';
    }
    return "".concat(localPart[0], "***@").concat(domain);
};
exports.anonymizeEmail = anonymizeEmail;
var getString = function (value) {
    return typeof value === 'string' && value.length > 0 ? value : null;
};
exports.getString = getString;
//# sourceMappingURL=string-utils.js.map